import React, { Component } from "react";
import { Container, Form, Message, Icon, Input, Popup, Label, Checkbox } from "semantic-ui-react";
import request from "../../utils/request";
import { AppContext } from "../../utils/context";
import ResponseMessage from "../../components/common/ResponseMessage";

const settingsInput = (self, key, props) => {
  let component = "";
  let inputName = props.varname;
  let inputVal = self.state.settings[inputName]
    ? self.state.settings[inputName]
    : props.value;
  if (props.settingtype === 'multiselect' && inputVal === '') {
     inputVal = '[]'
  }
  let inputLabel = (
    <label>
      <Popup
        key={key}
        trigger={
          <span>
            <Icon name="help circle" color="blue" fitted /> {props.title}
          </span>
        }
        content={props.description}
        inverted
        wide
      />
    </label>
  );
  let options = props.options;
  switch (props.settingtype) {
    case "":
      break;
    case "select":
      component = (
        <Form.Select
          key={key}
          label={inputLabel}
          name={inputName}
          options={options}
          defaultValue={inputVal}
          placeholder={props.varname}
          fluid
          onChange={self.handleChange}
        />
      );
       break;
      case "multiselect":
      component = (
        <Form.Select
          multiple
          key={key}
          label={inputLabel}
          name={inputName}
          options={options}
          defaultValue={(typeof inputVal) == 'string'  ? JSON.parse(inputVal) : inputVal}
          placeholder={props.varname}
          fluid
          onChange={self.handleChange}
        />
      );
       break;
      case "radio":
      component = (
        <div key={key} className="field">
          {inputLabel}
          <Form.Group inline>
            {options.map((value, index) => (
              <Form.Radio
                key={index}
                label={value.text}
                name={inputName}
                value={value.value}
                checked={inputVal === value.value}
                onChange={self.handleChange}
              />
            ))}
          </Form.Group>
        </div>
      );
      break;

    case "textarea":
      if (props.varname === "defaultprices") {
        let priceLevels = [];
        let length = self.state.settings["defaultprices"].length;
        for (let i = 0; i < length; i++) {
          let quantity = props.value[i].quantity;
          let price = props.value[i].price;
          let max_count = props.value[i].max_count;
          let label = props.value[i].label;
          let subscriptionChecked = self.state.subscriptionChecked;
          let subscriptionEnabled = self.state.subscriptionEnabled;
          priceLevels.push(
            <Form.Group key={i} widths="equal">
              <Label>{i < length/2 ? "Tablet" : "Web"}</Label>
              <Input
                label="#"
                name={props.varname + `.${i}.quantity`}
                placeholder="# of tickets"
                value={quantity}
                fluid
                onChange={self.handleChange}
              />
              <Input
                label="$"
                name={props.varname + `.${i}.price`}
                placeholder="0.00"
                value={price}
                fluid
                onChange={self.handleChange}
              />
              {+self.state.pricePointLimits > 0 &&
                <Input
                  label="limit"
                  name={props.varname + `.${i}.max_count`}
                  placeholder="0"
                  defaultValue={max_count}
                  fluid
                  onChange={self.handleChange}
                />
              }
              {+self.state.pricePointLabels > 0 && <Input
                label="label"
                name={props.varname + `.${i}.label`}
                placeholder=""
                defaultValue={label}
                maxLength="3"
                fluid
                onChange={self.handleChange}
              />}
              {subscriptionEnabled &&
                <Checkbox
                  label="Subscription"
                  name={props.varname + `.${i}.subscription`}
                  checked={subscriptionChecked[i]}
                  onChange={(e, { checked }) => self.handleChange(e, { name: props.varname + `.${i}.subscription`, checked })}
                />}
            </Form.Group>
          );
        }
        component = (
          <div key={key} className="field">
            {inputLabel}
            {priceLevels}
          </div>
        );
      } else {
        component = (
          <Form.TextArea
            key={key}
            name={inputName}
            defaultValue={inputVal}
            label={inputLabel}
            placeholder={props.varname}
            onChange={self.handleChange}
          />
        );
      }
      break;

    case "yesno":
      component = (
        <div key={key} className="field">
          {inputLabel}
          <Form.Group inline>
            <Form.Radio
              label="Yes"
              name={inputName}
              value="1"
              checked={inputVal === "1"}
              onChange={self.handleChange}
            />
            <Form.Radio
              label="No"
              name={inputName}
              value="0"
              checked={inputVal === "0"}
              onChange={self.handleChange}
            />
          </Form.Group>
        </div>
      );
      break;

    default:
      component = (
        <Form.Input
          key={key}
          name={inputName}
          defaultValue={inputVal}
          fluid
          label={inputLabel}
          placeholder={props.varname}
          onChange={self.handleChange}
        />
      );
      break;
  }

  return component;
};

class SettingsSystem extends Component {
  constructor(props, context) {
    super(props);
    this.state = {
      isLoading: true,
      xhrStatus: '',
      xhrMessage: '',
      fields: {},
      settings: {},
      pricePointLimits: context.config.pricepoint_limits_enabled,
      pricePointLabels: context.config.pricepoint_labels_enabled,
      defaultMaxTickets: context.config.maxtickets ? context.config.maxtickets : "999",
      subscriptionEnabled: context.config.subscription_enabled ? context.config.subscription_enabled : false,
      defaultMaxTickets: context.config.max_tickets ? context.config.max_tickets : "999",
      errorMaxTickets: '',
      errorInvalidEmail: "",
      subscriptionChecked: []

    };

    this.handleChange = this.handleChange.bind(this);
  }
  componentDidMount = () => {
    this.getSettings();
  };
  startLoading = () => {
    this.setState({
      isLoading: true,
      xhrStatus: '',
      xhrMessage: '',
      errorMaxTickets: "",
      errorInvalidEmail: ""
    });
  }
  doneLoading = () => {
    this.setState({
      isLoading: false
    });
  }
  getSettings = () => {
    this.startLoading();
    let settingsKey = "general";
    if (this.props.route.name === "settingsTablet") settingsKey = "tablet";
    if (this.props.route.name === "settingsWeb") settingsKey = "web";
    return request.get(this, "api:/settings", {}).then(resp => {
      let settingsData = resp.settings[settingsKey];
      let mapping = {};
      let subscriptionChecked = [];
      let filteredSettings = settingsData.filter(function (el) {
        mapping[el.varname] = el.value;
        if (el.varname.indexOf('defaultprices') >= 0) {
          subscriptionChecked =  el.value.map(pp => pp.subscription === "1")
        }

        if (el.varname.indexOf('color') < 0 && el.varname.indexOf('cookie') < 0) {
          settingsData[el.varname] = el.value;
          return settingsData;
        }
      });
      this.setState({
        subscriptionChecked: subscriptionChecked,
        fields: filteredSettings,
        settings: mapping
      }, () => this.doneLoading());
    });
  };
  emailValidation = (email) => {
    const regex = /^[-!#-'*+\/-9=?^-~]+(?:\.[-!#-'*+\/-9=?^-~]+)*@[-!#-'*+\/-9=?^-~]+(?:\.[-!#-'*+\/-9=?^-~]+)+(?:\s*,\s*[-!#-'*+\/-9=?^-~]+(?:\.[-!#-'*+\/-9=?^-~]+)*@[-!#-'*+\/-9=?^-~]+(?:\.[-!#-'*+\/-9=?^-~]+)+)*$/i;
    if (email === "") {
      this.setState({errorInvalidEmail: ""});
    } else if (!regex.test(email)) {
      this.setState({errorInvalidEmail: "There is an invalid email, please ensure all emails are valid and separated by a comma" });
    } else if (this.state.xhrStatus !== "error") {
      this.setState({errorInvalidEmail: ""})
    }
  }
  handleChange = (e, { name, value, checked }) => {
    let data = { ...this.state.settings };
    let defaultMaxTickets = this.state.defaultMaxTickets;
    let errorMaxTickets = this.state.errorMaxTickets;
    // Handle settings default prices
    if (name.indexOf("defaultprices") >= 0) {
      // validate quantity field
      if (name.indexOf('.quantity') >= 0) {
        if (isNaN(value) || value === "") {
          value = "";
        } else {
          value = Math.max(1, parseInt(value));
          // max_tickets setting check
          errorMaxTickets = '';
          if (parseInt(value) > parseInt(defaultMaxTickets)) {
            value = parseInt(defaultMaxTickets);
            errorMaxTickets = `The maximum quantity for this pricepoint is ${defaultMaxTickets}. If you do not provide a value ${defaultMaxTickets} or below, then the quantity is automatically set to ${defaultMaxTickets}.`;
          }
        }
      }
      // validate quantity field
      if (name.indexOf('.price') >= 0) {
        if (isNaN(value) || value === "") {
          value = "";
        } else {
          value = Math.max(1, parseInt(value));
        }
      }

      if (name.indexOf('.subscription') >= 0) {
          let index = name.split('.')[1];
          const { subscriptionChecked } = this.state;
          subscriptionChecked[index] = checked;
          this.setState({
            subscriptionChecked: subscriptionChecked
          });
          value = checked ? "1" : "0";
        }

      // }
      // assign value entered to appropriate pricepoint set
      for (var i = 0; i < data.defaultprices.length; i++) {
        if (name === `defaultprices.${i}.quantity`)
          data.defaultprices[i].quantity = value;
        if (name === `defaultprices.${i}.price`)
          data.defaultprices[i].price = value;
        if (name === `defaultprices.${i}.max_count`)
          data.defaultprices[i].max_count = value;
        if (name === `defaultprices.${i}.label`)
          data.defaultprices[i].label = value;
        if (name === `defaultprices.${i}.subscription`){
          data.defaultprices[i].subscription = value;
        }
      }
    } else {
      data[name] = value;
    }
    this.setState({ settings: data, errorMaxTickets });
  };
  handleSubmit = () => {
    if (this.state.errorInvalidEmail === "") {
      this.startLoading();
      return request
        .post(this, "api:/settings", this.state.settings)
        .then(resp => {
          this.setState({
            xhrStatus: resp.success ? "success" : "error",
            xhrMessage: resp.message
          }, () => this.doneLoading());
          if (resp.success) {
            setTimeout(() => this.setState({ xhrStatus: '', xhrMessage: '' }), 4000);
          }
        });
    } else {
      this.setState({xhrStatus: "error"})
    }
  };
  handleDismissPortal = (e) => {
    if (e.target.name === "email_list_after_draw")this.emailValidation(e.target.value);
    else if (this.state.xhrStatus === '') return null;

    this.setState({ xhrStatus: '', xhrMessage: '', errorMaxTickets: '' });
  }

  render() {
    const { fields, isLoading, xhrStatus, xhrMessage, errorMaxTickets, errorInvalidEmail } = this.state;
    return (
      <Container text>
        <Form
          loading={isLoading}
          success={xhrStatus === "success"}
          error={xhrStatus === "error" || (errorMaxTickets !== "" ? true : false) || (errorInvalidEmail === "" ? true : false)}
          onSubmit={this.handleSubmit}
          onBlur={this.handleDismissPortal}
        >
          <Form.Button
            primary
            floated='right'
            icon="save"
            content="Save"
            style={{
              right: '2.5%',
              position: 'fixed',
              bottom: '2.5%',
              zIndex: 1000
            }}
          />
          {!isLoading && fields.map((value, index) => settingsInput(this, index, value))}
          <ResponseMessage status={xhrStatus} message={xhrMessage || errorMaxTickets || errorInvalidEmail} />
        </Form>
      </Container>
    );
  }
}

SettingsSystem.contextType = AppContext;

export default SettingsSystem;
